<template>
  <div class="order_box" ref="search" id="search" :style="{'transform': transform, 'top': top, 'left':left}">
    <div class="head_top">
      <div class="left">
        <img :src="logoImg" alt="">
        <div>跨境贸易大数据平台</div>
      </div>
    </div>
    <div>
      <div class="search-head">
        <div>
          <router-link tag="span" :to="{name: 'bigDataHome'}" class="setCursor">跨境大数据平台</router-link> > 订单跟踪
        </div>
        <div class='close' @click='doReturn'>
          <img src='@/assets/images/home/back.png'/>
          返回
        </div>
      </div>
    </div>
    <div class="orderDetail">
      <h1 style="padding: 40px 40px 0;">订单跟踪<span style="font-size: 15px;color: rgb(204 204 204);">（订单号171-4039624-7843510）</span></h1>
      <div class='title_box'><div class='icon'></div>订单（来源：Amazon）</div>
      <div class='jbxx-item'>
        <div class='title'>订单信息</div>
        <div class='base-list'>
          <el-row class='row'>
            <el-col v-for='(item, index) in orderInfo' :key='index' type='flex' :span='8'>
              <el-row>
                <el-col class='border' :span='8'>{{item.name}}</el-col>
                <el-col class='border' :span='16'>
                  <el-tooltip
                    effect="dark"
                    placement="top"
                    :content="String(item.value)"
                    :open-delay="300"
                    >
                    <div>{{item.value}}</div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class='jbxx-item'>
        <div class='title'>产品信息</div>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='productInfoData'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in productInfoHeader' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class='title_box'><div class='icon'></div>支付记录（来源：Amazon）</div>
      <div class='jbxx-item'>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='paymentData'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in paymentHeader' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class='title_box'><div class='icon'></div>物流记录（来源：物流服务商）</div>
      <div class='jbxx-item'>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='logisticsData'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in logisticsHeader' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class='title_box'><div class='icon'></div>物流轨迹（来源：物流服务商/17track）</div>
      <div class='jbxx-item'>
        <div style="padding: 10px 40px;">17track查询链接 <a href="https://t.17track.net/zh-cn#nums=34798032845173" target="_blank">https://t.17track.net/zh-cn#nums=34798032845173</a></div>
        <div class='title'>物流轨迹</div>
        <div class='base-list'>
          <div class="logisticsTrajectoryInfo">
            <div>成功签收 - 签收时间：2023-06-14</div>
            <div>您的包裹已经成功签收。</div>
            <div>2023-10-18 18:22:36 (GMT+08:00)</div>
          </div>
          <div class="logisticsTrajectoryList">
            <div :key="key" v-for="(item, key) in logisticsTrajectoryList">
              <span>{{item.time}}</span>
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class='title_box'><div class='icon'></div>报关记录（来源：平台报关服务商）</div>
      <div class='jbxx-item'>
        <div class='title'>订单申报</div>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='declarationData1'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in declarationHeader1' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class='jbxx-item'>
        <div class='title'>收款单申报</div>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='declarationData2'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in declarationHeader2' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class='jbxx-item'>
        <div class='title'>运单申报</div>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='declarationData3'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in declarationHeader3' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div> -->

      <div class='jbxx-item'>
        <div class='title'>清单申报</div>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='declarationData4'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in declarationHeader4' :label='props.label' align='center' :key='i' show-overflow-tooltip min-width="150px">
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class='title_box'><div class='icon'></div>九江市综服平台</div>
      <div class='jbxx-item'>
        <div class="link_box"><a href="http://106.225.177.37:11188/login" target="_blank">点击跳转查询</a></div>
        <div class='title'>出口清单表头</div>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='jjData1'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in jjHeader1' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div class='jbxx-item'>
        <div class='title'>出口清单表体</div>
        <div class='ux-tabs tabs' style='margin:0 40px;
          width:calc(100% - 80px);min-height:100px'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                empty-text="暂无数据"
                class='table ux-dark-el-table'
                :data='jjData2'
                element-loading-spinner='el-icon-loading'>
                  <el-table-column v-for='(props, i) in jjHeader2' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <div class='text'>{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class='title_box'><div class='icon'></div>单一窗口</div>
      <div class='jbxx-item'>
        <div class="link_box"><a href="https://www.singlewindow.cn/#/" target="_blank">点击跳转查询</a></div>
      </div>

    </div>
  </div>
</template>

<script>
const projectData = require('@/utils/projectData.json')
const hostPath = require('@config/host')
export default {
  components: {},

  data () {
    return {
      transform: 'scale(1,1)',
      top: 0,
      left: 0,
      orderInfo: [
        {
          name: '订单编号',
          value: '171-4039624-7843510'
        },
        {
          name: '平台名称',
          value: 'Amazon'
        },
        {
          name: '站点',
          value: 'SA'
        },
        {
          name: '店铺名称',
          value: 'Shell-TS'
        },
        {
          name: '订单总金额',
          value: '72.89'
        },
        {
          name: '下单时间',
          value: '2023-05-30 04:49:28'
        },
        {
          name: '发货状态',
          value: '已发货'
        }
      ],
      productInfoHeader: [
        {
          prop: 'name',
          label: '商品名称'
        },
        {
          prop: 'mode',
          label: '规格型号'
        },
        {
          prop: 'num',
          label: '订购数量（套）'
        },
        {
          prop: 'price',
          label: '商品价格'
        },
        {
          prop: 'currency',
          label: '币种'
        },
        {
          prop: 'total',
          label: '总价'
        }
      ],
      productInfoData: [
        {
          name: 'Mosquito Net, GoolRC White Camping Mosquito Net Outdoor Anti-mosquito Insect Mesh Tent Net ',
          mode: 'SAWJ-Y16414-3-ZHY',
          num: '1',
          price: '72.89',
          currency: 'SAR',
          total: '72.89'
        }
      ],
      paymentHeader: [
        { prop: 'no', label: '订单编号' },
        { prop: 'type', label: '付款类型' },
        { prop: 'freight', label: '运费USD' },
        { prop: 'status', label: '支付状态' },
        { prop: 'tatal', label: '订单总价' },
        { prop: 'currency', label: '订单总价币种' },
        { prop: 'time', label: '付款时间' }
      ],
      paymentData: [
        {
          no: '171-4039624-7843510',
          type: '其他',
          freight: '0',
          status: '已支付',
          tatal: '72.89',
          currency: 'SAR',
          time: '2023-05-30 04:49:28'
        }
      ],
      logisticsHeader: [
        { prop: 'orderNo', label: '订单编号' },
        { prop: 'tatal', label: '订单总金额' },
        { prop: 'no', label: '物流运单编号' },
        { prop: 'name', label: '物流企业名称' },
        { prop: 'country', label: '运抵国（地区）' },
        { prop: 'num', label: '件数' },
        { prop: 'gw', label: '毛重（KG）' },
        { prop: 'nw', label: '净重（KG）' },
        { prop: 'freight', label: '运费' }
      ],
      logisticsData: [
        {
          orderNo: '171-4039624-7843510',
          tatal: '72.89',
          no: '34798032845173',
          name: '飞坦数字物流',
          country: '沙特阿拉伯',
          num: '1',
          gw: '0.421',
          nw: '0.39995',
          freight: '0'
        }
      ],
      logisticsTrajectory: [
        { name: '单号', value: 'xxx' },
        { name: '包裹状态', value: 'xxx' },
        { name: '国家', value: 'xxx' }
      ],
      logisticsTrajectoryList: [
        {name: 'Delivered', time: '2023-06-14 14:36'},
        {name: 'Shipment out for delivery', time: '2023-06-14 08:26'},
        {name: 'Undelivery', time: '2023-06-13 13:52'},
        {name: '', time: '2023-06-06 22:46'},
        {name: 'Shipment in transit', time: '2023-06-06 19:31'},
        {name: 'LM team picked up', time: '2023-06-06 18:04'},
        {name: 'Arrived at sorting hub facility', time: '2023-06-06 18:04'},
        {name: 'Arrived at sorting hub facility', time: '2023-06-06 11:05'},
        {name: 'Shenzhen Facility, Dispatch to destination country', time: '2023-06-02 17:01'},
        {name: 'Shenzhen Facility, Shipment picked up from shipper', time: '2023-06-02 17:00'},
        {name: 'Data received', time: '2023-05-30 07:21'}
      ],
      declarationHeader1: [
        { prop: 'item1', label: '系统唯一编号' },
        { prop: 'item2', label: '报送类型' },
        { prop: 'item3', label: '报送时间' },
        { prop: 'item4', label: '报送状态' },
        { prop: 'item5', label: '订单类型' },
        { prop: 'item6', label: '电商平台订单号' },
        { prop: 'item7', label: '电商平台代码' },
        { prop: 'item8', label: '电商平台名称' },
        { prop: 'item9', label: '电商企业代码' },
        { prop: 'item10', label: '电商企业名称' },
        { prop: 'item11', label: '商品金额' },
        { prop: 'item12', label: '运杂费' },
        { prop: 'item13', label: '币制' },
        { prop: 'item14', label: '备注' }
      ],
      declarationData1: [
        {
          item1: 'ORDER2023060200001000870019080091000',
          item2: '1',
          item3: '2023/06/02 19:07:42',
          item4: '2',
          item5: 'E',
          item6: 'A171-4039624-7843510',
          item7: '3604960ADU',
          item8: '共青城通赣信息科技有限公司',
          item9: '3604960ADU',
          item10: '共青城通赣信息科技有限公司',
          item11: '5.82',
          item12: '-',
          item13: '502',
          item14: '安梭#通赣'
        }
      ],
      declarationHeader2: [
        { prop: 'item1', label: '系统唯一编号' },
        { prop: 'item2', label: '报送类型' },
        { prop: 'item3', label: '报送时间' },
        { prop: 'item4', label: '报送状态' },
        { prop: 'item6', label: '电商平台订单号' },
        { prop: 'item7', label: '电商平台代码' },
        { prop: 'item8', label: '电商平台名称' },
        { prop: 'item9', label: '电商企业代码' },
        { prop: 'item10', label: '电商企业名称' },
        { prop: 'item15', label: '支付企业名称' },
        { prop: 'item16', label: '支付交易编号' },
        { prop: 'item11', label: '商品金额' },
        { prop: 'item12', label: '币制' },
        { prop: 'item13', label: '到账时间' },
        { prop: 'item14', label: '备注' }
      ],
      declarationData2: [
        {
          item1: 'RECEIPT20230602000010006600191245950',
          item2: '1',
          item3: '2023/06/02 19:07:43',
          item4: '2',
          item6: 'A171-4039624-7843510',
          item7: '3604960ADU',
          item8: '共青城通赣信息科技有限公司',
          item9: '3604960ADU',
          item10: '共青城通赣信息科技有限公司',
          item15: '第三方电商平台',
          item16: '-',
          item11: '5.82',
          item12: '502',
          item13: '2023/06/02 18:54:14',
          item14: '安梭#通赣'
        }
      ],
      declarationHeader3: [
        { prop: 'item1', label: '系统唯一编号' },
        { prop: 'item2', label: '报送类型' },
        { prop: 'item3', label: '报送时间' },
        { prop: 'item4', label: '报送状态' },
        { prop: 'item5', label: '订单类型' },
        { prop: 'item6', label: '电商平台订单号' },
        { prop: 'item7', label: '电商平台代码' },
        { prop: 'item8', label: '电商平台名称' },
        { prop: 'item9', label: '电商企业代码' },
        { prop: 'item10', label: '电商企业名称' },
        { prop: 'item11', label: '商品金额' },
        { prop: 'item12', label: '运杂费' },
        { prop: 'item13', label: '币制' },
        { prop: 'item14', label: '备注' }
      ],
      declarationData3: [],
      declarationHeader4: [
        { prop: 'item1', label: '系统唯一序号' },
        { prop: 'item2', label: '企业报送类型' },
        { prop: 'item3', label: '企业报送时间' },
        { prop: 'item4', label: '企业报送状态' },
        { prop: 'item5', label: '申报地海关代码' },
        { prop: 'item6', label: '电商平台代码' },
        { prop: 'item7', label: '电商平台名称/海外仓名称' },
        { prop: 'item8', label: '订单编号/海外仓订仓编号' },
        { prop: 'item9', label: '物流企业代码' },
        { prop: 'item10', label: '物流企业名称' },
        { prop: 'item11', label: '物流运单编号' },
        { prop: 'item12', label: '企业唯一编号' },
        { prop: 'item13', label: '电子口岸标识唯一编号' },
        { prop: 'item14', label: '清单编号' },
        { prop: 'item15', label: '进出口标记' },
        { prop: 'item16', label: '出口口岸代码' },
        { prop: 'item17', label: '出口日期' },
        { prop: 'item18', label: '申报业务类型' },
        { prop: 'item19', label: '申报业务代码' },
        { prop: 'item20', label: '申报企业名称' },
        { prop: 'item21', label: '收发货人代码' },
        { prop: 'item22', label: '收发货人名称' },
        { prop: 'item23', label: '生产销售企业代码' },
        { prop: 'item24', label: '生产销售企业名称' },
        { prop: 'item25', label: '区内企业代码' },
        { prop: 'item26', label: '区内企业名称' },
        { prop: 'item27', label: '账册编号' },
        { prop: 'item28', label: '贸易方式' },
        { prop: 'item29', label: '运输方式代码' },
        { prop: 'item30', label: '运输工具名称' },
        { prop: 'item31', label: '航班航次号' },
        { prop: 'item32', label: '提单或总运单的编号' },
        { prop: 'item33', label: '总包号' },
        { prop: 'item34', label: '监管场所' },
        { prop: 'item35', label: '进出口货物许可证的编号' },
        { prop: 'item36', label: '运抵国（地区）' },
        { prop: 'item37', label: '指运港代码' },
        { prop: 'item38', label: '运费' },
        { prop: 'item39', label: '运费币制' },
        { prop: 'item40', label: '运费标志' },
        { prop: 'item41', label: '保费' },
        { prop: 'item42', label: '保费币制' },
        { prop: 'item43', label: '保费标志' },
        { prop: 'item44', label: '包装种类代码' },
        { prop: 'item45', label: '件数' },
        { prop: 'item46', label: '毛重（公斤）' },
        { prop: 'item47', label: '净重（公斤）' },
        { prop: 'item48', label: '备注' }
      ],
      declarationData4: [
        {
          item1: 'CUSTOMS20230602000010007800191601390',
          item2: '1',
          item3: '20230602190742',
          item4: '2',
          item5: '5314',
          item6: '3604960ADU',
          item7: '共青城通赣信息科技有限公司',
          item8: 'A171-4039624-7843510',
          item9: '4403180248',
          item10: '深圳市安梭国际货运代理有限公司',
          item11: 'A34798032845173',
          item12: 'COP20230602001002200191601170',
          item13: 'B20230425100000001',
          item14: '00202023E100000001',
          item15: 'E',
          item16: '5345',
          item17: '20230602',
          item18: 'B',
          item19: '3604960ADU',
          item20: '共青城通赣信息科技有限公司',
          item21: '3604960ADU',
          item22: '共青城通赣信息科技有限公司',
          item23: '3604960ADU',
          item24: '共青城通赣信息科技有限公司',
          item25: '-',
          item26: '-',
          item27: '-',
          item28: '9610',
          item29: '4',
          item30: '汽车',
          item31: '粤ZAN27港',
          item32: '5100651187426',
          item33: '-',
          item34: '531496',
          item35: '无',
          item36: '131',
          item37: '110',
          item38: '0',
          item39: '502',
          item40: '3',
          item41: '0',
          item42: '502',
          item43: '3',
          item44: '6',
          item45: '1',
          item46: '0.421',
          item47: '0.39995',
          item48: '安梭#通赣'
        }
      ],
      jjHeader1: [
        { prop: 'item1', label: '订单编号' },
        { prop: 'item2', label: '运单编号' },
        { prop: 'item3', label: '提运单号' },
        { prop: 'item4', label: '清单编号' },
        { prop: 'item6', label: '预录入编号' },
        { prop: 'item7', label: '件数' },
        { prop: 'item8', label: '商品金额' },
        { prop: 'item9', label: '币制' },
        { prop: 'item10', label: '毛重' },
        { prop: 'item15', label: '运输方式' },
        { prop: 'item16', label: '状态' },
        { prop: 'item11', label: '航班航次号' },
        { prop: 'item12', label: '申报时间' },
        { prop: 'item13', label: '离境时间' }
      ],
      jjData1: [
        {
          item1: 'A171-4039624-7843510',
          item2: 'A34798032845173',
          item3: '5100651187426',
          item4: '53142023E2251225122',
          item6: 'B20230602476578375',
          item7: '1',
          item8: '19.3',
          item9: '美元',
          item10: '0.421',
          item15: '公路运输',
          item16: '正常',
          item11: '粤ZAN27港',
          item12: '2023-06-02 19:07:00',
          item13: '2023-06-02 00:00:00'
        }
      ],
      jjHeader2: [
        { prop: 'item1', label: '支付编号' },
        { prop: 'item2', label: '净重' },
        { prop: 'item3', label: '电商平台' },
        { prop: 'item4', label: '支付企业' },
        { prop: 'item6', label: '生产销售企业' },
        { prop: 'item7', label: '监管场所经营人' },
        { prop: 'item8', label: '后续报关单申报单位' },
        { prop: 'item9', label: '特殊区域内仓储企业' },
        { prop: 'item10', label: '运抵国(地区)' },
        { prop: 'item15', label: '指运港(目的港)' },
        { prop: 'item16', label: '监管场所代码' }
      ],
      jjData2: [
        {
          item1: 'Y26021G',
          item2: '53142023E2251225122',
          item3: '共青城通赣信息科技有限公司',
          item4: '共青城通赣信息科技有限公司',
          item6: '共青城通赣信息科技有限公司',
          item7: '共青城通赣信息科技有限公司',
          item8: '共青城通赣信息科技有限公司',
          item9: '共青城通赣信息科技有限公司',
          item10: '沙特阿拉伯',
          item15: '110',
          item16: '531496'
        }
      ]
    }
  },

  computed: {},
  watch: {},
  created () {
    this.logoImg = projectData[hostPath.sysType].logo
  },

  mounted () {},

  methods: {
    // 返回
    doReturn () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
  .order_box{
    .head_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding:0 16px;
      height: 40px;
      font-size: 18px;
      margin-top:16px;
      .left{
        display: flex;
        align-items: center;
      }
      .right{
        display: flex;
        align-items: center;
        width: 137px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        padding-left: 58px;
        color: #E2F0FE;
        background: url('~@/assets/images/home/out.png') no-repeat 0 0;
        .right-list{
          position: absolute;
          right: 22px;
          top: 66px;
          width: 188px;
          border-radius: 8px;
          background: rgba(71, 90, 179, 0.8);
          z-index: 999;
          div{
            height:35px;
            line-height: 35px;
            width: 188px;
            text-align: center;
          }
        }
      }
    }
    .search-head{
      line-height: 40px;
      font-size: 20px;
      line-height: 40px;
      margin-left: 32px;
      margin-right: 32px;
      padding-top: 16px;
      display: flex;
      position: relative;
      align-items: center;
      justify-content: space-between;
      .close{
        width: 87px;
        height: 30px;
        cursor: pointer;
        align-items:center;
        display: flex;
        img{
          width: 24px;
          height: 24px;
          margin-right:10px;
        }
      }
      .buttons{
        display: flex;
        align-items: center;
        position: absolute;
        right: 12px;
        height: 36px;
        top: 64px;
        .time{
          margin-right: 16px;
        }
      }
    }
    .title_box{
      display: flex;
      font-size:18px;
      margin-left: 40px;
      padding: 30px 0 5px;
      .icon{
        width: 20px;
        height: 20px;
        border-radius: 4px;
        background: rgb(71,166,234);
        margin-right:16px;
      }
    }
  }
</style>
<style lang="scss">
  .order_box{
    padding-bottom: 50px;
    .ux-filter-records {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      // padding: 20px 30px 0;
      box-sizing: border-box;
      .filter {
        display: flex;
        flex-wrap: wrap;
        .search {
          color: #ffffff;
          background: #1c8be2;
        }
      }
      .content-list {
        margin-top: 10px;
        flex: none;
        // min-height: 517px;
        .blue{
          color: #1c8be2;
          cursor: pointer;
        }
        .table {
          height: 100%;
          .el-table__header-wrapper {
            tr {
              th {
                height: 50px;
              }
            }
          }
          .el-table__body-wrapper {
            tr {
              td {
                height: 50px;
              }
            }
          }
          .el-loading-mask {
            // background: rgba(0, 0, 0, 0.8);
            .el-loading-spinner {
              font-size: 24px;
            }
          }
          .text {
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
        .ux-dark-el-table {
          display: flex;
          flex-direction: column;
          border: 1px solid #2d6bab;
          background-color: transparent;
          table {
            tr {
              background: rgba(24, 127, 215, 0.1) !important;
              &:last-child {
                td {
                  border-bottom: none;
                }
              }
              th {
                padding: 0;
                border-color: #2d6bab !important;
                background: rgba(24, 127, 215, 0.3) !important;
                &:last-child {
                  border-right: none;
                }
                .cell {
                  font-size: 16px;
                  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                  font-weight: 500;
                  color:#fff;
                  // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                  // background-clip: text;
                  // -webkit-text-fill-color: transparent;
                }
              }
              td {
                padding: 0;
                font-size: 14px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color: #ffffff;
                border-color: #2d6bab;
                &:last-child {
                  border-right: none;
                }
              }
            }
          }
          td.el-table__cell{
            border-bottom: 1px solid #2d6bab;
          }
          &::before {
            display: none;
          }
          // tbody row hover
          &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background: rgba(24, 127, 215, 0.2);
          }
          // 多级表头
          &.el-table--group::after,
          // 带边框表格
          &.el-table--border::after {
            content: unset;
          }
          .el-table__body-wrapper {
            flex: 1 1;
            table {
              height: 100%;
            }
          }
          .el-table__footer-wrapper tbody td.el-table__cell {
            font-size: 16px;
            background-color: transparent;
          }
        }
      }
      .pages {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 28px;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
      }
    }
    .orderDetail{
      padding-top: 20px;
      .jbxx-item{
        .title{
          color:#fff;
          font-size:18px;
          margin-top:18px;
          margin-left:40px;
        }
        .title2 {
          margin-left:40px;
          font-size: 14px;
          color: #777984;
        }
        .mTop{
          margin-top:18px;
        }
        .base-list{
          margin:0 40px;
          margin-top: 16px;
          border:1px solid #22bdfe;
          .row{
            font-size:16px;
            line-height: 40px;
          }
          .border{
            border:1px solid #22bdfe;
            text-align: center;
            height: 36px;
            line-height: 36px;
            overflow-y: hidden;
            // width: 100%;
            overflow-x: auto;
          }
        }
        .img-list{
          display: flex;
          margin:0 40px;
          margin-top: 16px;
          flex-wrap: wrap;
          width: calc(100% - 80px);
          .photos_image{
            width: 100px;
            height: 100px;
            margin-right:16px;
            margin-bottom:8px;
          }
        }
      }
    }
    .logisticsTrajectoryInfo {
      font-size: 16px;
      padding: 20px 20px 0;
    }
    .logisticsTrajectoryList {
      padding: 10px 20px 20px 44px;
    }
    .link_box {
      padding: 20px 40px;
      font-size: 16px;
      a {
        color: #47a6ea;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/order/detail/index.vue